import { APIClient, ApiQueryParams } from '@frontend/api-utils';
import {
    CreateTransactionAttachment,
    TransactionAttachment,
    TransactionAttachmentListResponse,
    TransactionAttachmentQueryParams
} from '@frontend/transaction/types';

export class TransactionAttachmentClient extends APIClient {
    public static readonly endpoint = '/transaction-api/v1';

    public static async fetchTransactionAttachments(
        queryParams?: ApiQueryParams<TransactionAttachmentQueryParams>
    ): Promise<TransactionAttachmentListResponse> {
        return await this.apiPaginated<TransactionAttachmentListResponse, TransactionAttachmentQueryParams>(`${this.endpoint}/attachments`, queryParams);
    }

    public static async resolveTransactionAttachments(attachmentIds: string[]): Promise<TransactionAttachmentListResponse> {
        const response = await this.post(`${this.endpoint}/attachments-resolve`, { ids: attachmentIds });
        return await this.handleResponse<TransactionAttachmentListResponse>(response);
    }

    public static async postTransactionAttachment(
        accountId: string,
        transactionId: string,
        createTransactionAttachment: CreateTransactionAttachment
    ): Promise<TransactionAttachment> {
        const response = await this.post(`${this.endpoint}/accounts/${accountId}/transactions/${transactionId}/attachments`, createTransactionAttachment);
        return await this.handleResponse<TransactionAttachment>(response);
    }

    public static async fetchTransactionAttachment(accountId: string, transactionId: string, attachmentId: string): Promise<TransactionAttachment> {
        const response = await this.fetch(`${this.endpoint}/accounts/${accountId}/transactions/${transactionId}/attachments/${attachmentId}`);
        return await this.handleResponse<TransactionAttachment>(response);
    }

    public static async deleteTransactionAttachment(accountId: string, transactionId: string, attachmentId: string): Promise<void> {
        const response = await this.delete(`${this.endpoint}/accounts/${accountId}/transactions/${transactionId}/attachments/${attachmentId}`);
        return await this.handleVoidResponse(response);
    }
}
